/**
 * @file prefetch工具函数（prefetch.js会单独打包，所以把依赖的工具函数从util.js中提出来）
 * @author tangyu04
 */
/* globals getApp swan */

/**
 * 小程序版本号比较--2.0.13以上版本才支持评论功能
 * APP版本号比较--11.1.0（android）、11.2.0（IOS）以上版本才支持自定义头部
 * 2019-08-13更改
 *      由于小程序目前更新逻辑均在11.2.0（swan 3.0.30）版本以上，故均为高版本
 *      故下掉高低版本鉴定，均为高版本，保留版本对比逻辑
 *
 * @param {string} v1 版本号
 * @param {string} v2 版本号
 * @return {number}
 */

export let compareVersion = function (v1, v2) {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i], 10);
    const num2 = parseInt(v2[i], 10);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
};

/**
 * 同步获取设备信息
 *
 * @param {number} force 强制从接口获取
 * @return {swan.getSystemInfoSync.Return}
 */

export const getSystemInfoSync = function (force = 0) {
  let app = getApp();
  // 如果不强制从接口获取sysInfo时
  // 优先从globalData里面取
  if (!force && app && app.globalData && app.globalData.platform) {
    return app.globalData;
  }
  let res = getApp().$api.getSystemInfoSync();
  if (res && res.platform) {
    if (/iphone\s?(x|1[1-3])/i.test(res.model)) {
      res.isIphoneX = true;
    }
    res.appVersion = res.version;
    res.titleBarHeight = res.navigationBarHeight;
    res.totalTitleHeight = res.titleBarHeight + res.statusBarHeight;
    delete res.version;
    // swan-native版本大于等于2.18.0 lottie可以展示
    res.canLottieShow = [1, 0].includes(compareVersion(res.swanNativeVersion, '2.18.0'));
    // 百度极速版	不能展示带有tt效果的lottie
    res.canTTLottieShow = res.host !== 'bdlite';
    app.globalData = {
      ...(app.globalData || {}),
      ...(res || {})
    };
    // 将设备信息缓存起来
    // swan.setStorageSync('sysInfo', res);
    return res;
  }
  return {};
};